import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { KeyValue } from '@angular/common';

@Component({
    selector: 'app-sw-reset-option',
    imports: [MatFormFieldModule, MatSelectModule, MatInputModule, FormsModule],
    templateUrl: './sw-reset-option.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sw-reset-option.component.scss'
})
export class SwResetOptionComponent {
    @Input() label: string = '';
    @Input() value: string = '0';
    @Input() data: KeyValue<string, string>[] = [];
    @Output() selectionChangedEvent = new EventEmitter<string>();

    onSelectionChange(event: any) {
        this.selectionChangedEvent.emit(event.value);
    }
}
